import React from 'react';
import { Query } from 'react-apollo';
import { Redirect, RouteComponentProps, withRouter } from 'react-router';

import * as moment from 'moment';
import { LOGIN } from '../../constants/route';
import { FETCH_ME_QUERY, FetchMeQueryResult, LoginQueryResult } from '../../containers/Login/Login.queries';
import { insiderService } from '../../services/InsiderService';

interface WithAuthProps {
  Component: React.ComponentType<any>;
  authenticationRequired: boolean;
  componentProps?: any;
}

type AuthRouteProps = WithAuthProps & RouteComponentProps<any>;

class AuthRoute extends React.Component<AuthRouteProps> {
  render() {
    return (
      <Query<FetchMeQueryResult>
        query={FETCH_ME_QUERY}
        fetchPolicy={'network-only'}
        onCompleted={this.handleQueryCompleted}
      >
        {this.renderQuery}
      </Query>
    );
  }

  private readonly handleQueryCompleted = (data: FetchMeQueryResult) => {
    if (data.me) {
      this.identifyInsiderUser(data.me);
    }
  };

  private readonly renderQuery = ({ loading, data }: { loading: boolean; data?: FetchMeQueryResult }) => {
    return loading ? null : this.handleRender(data);
  };

  private readonly identifyInsiderUser = (me: LoginQueryResult) => {
    insiderService.identify({
      birthday: me.birthdate ? moment(me.birthdate).format('YYYY-MM-DD') : undefined,
      email: me.email,
      email_optin: true,
      gdpr_optin: true,
      gender: me.gender ? me.gender.charAt(0).toUpperCase() : undefined,
      language: 'en_US',
      name: me.name,
      phone_number: me.phoneNo,
      sms_optin: true,
      uuid: me.id,
      whatsapp_optin: true
    });
    insiderService.setCurrency('IDR');
  };

  private readonly handleRender = (data?: FetchMeQueryResult) => {
    const { Component, authenticationRequired, location } = this.props;

    if (data && data.me) {
      return <Component {...this.props.componentProps} me={data.me} />;
    } else if (authenticationRequired) {
      return <Redirect to={{ pathname: LOGIN.path, state: { from: location } }} />;
    } else {
      return <Component {...this.props.componentProps} />;
    }
  };
}

const ConnectedAuthRoute = withRouter(AuthRoute);

export const withAuth = (props: WithAuthProps) => <ConnectedAuthRoute {...props} />;

export interface AuthProps {
  me: LoginQueryResult;
}
